import * as React from "react";
const IconGn = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h512v342H0z" />
    <path  d="M342 0h171v342H342z" />
    <path  d="M0 0h171v342H0z" />
  </svg>
);
export default IconGn;
